<div class="modal-header">
  <h4 class="modal-title">Import loans</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span>&times;</span>
  </button>
</div>
<div class="modal-body" [formGroup]="loansImportForm">

        <div class="form-check mb-4">
          <input type="checkbox" class="form-check-input" id="markAsPreSold" formControlName="markAsPreSold">
          <label class="form-check-label" for="markAsPreSold">Mark as pre-sold</label>
        </div>

        <div class="form-group custom-file">
          <input type="file"
                 class="form-control form-control-sm custom-file-input"
                 id="file"
                 formControlName="file"
                 name="file"
                 accept=".txt"
                 (change)="fileProgress($event)"/>
          <label class="custom-file-label" for="file">Choose file...</label>
        </div>
        <div class="mt-3" *ngIf="fileData?.name">
          <div class="d-inline-block position-relative">
            <span>{{fileData?.name}}</span>
          </div>
        </div>

</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="activeModal.close('Close click')">Close</button>
  <button type="submit" class="btn btn-outline-danger" [disabled]="!loansImportForm.valid" (click)="submitForm()">Import</button>
</div>






